
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"125","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2222"}},[_c('path',{attrs:{"data-name":"Rectangle 2941","fill":"none","d":"M0 0h125v120H0z"}}),_c('path',{attrs:{"data-name":"Path 1359","d":"M96 20H4a4 4 0 00-4 4v72a4 4 0 004 4h92a4 4 0 004-4V24a4 4 0 00-4-4zm-4 55.434a15.925 15.925 0 010-30.867zM50 66a6 6 0 116-6 6.006 6.006 0 01-6 6zM8 44.57a15.918 15.918 0 010 30.856zm0 39.059a23.958 23.958 0 000-47.258v-8.375h38v18.039a3.729 3.729 0 00.117.586 13.9 13.9 0 000 26.758 3.729 3.729 0 00-.117.586v18.039H8zm46 8.375V73.965a3.728 3.728 0 00-.117-.586 13.9 13.9 0 000-26.758 3.729 3.729 0 00.117-.586V27.996h38v8.368a23.967 23.967 0 000 47.273v8.367z","fill":"#9ea7e9"}}),_c('path',{attrs:{"data-name":"Path 1360","d":"M96 20H4a4 4 0 00-4 4v72a3.981 3.981 0 001.084 2.725L22.359 120H125V47.36L98.916 21.276A3.98 3.98 0 0096 20z","fill":"#3838d2"}}),_c('path',{attrs:{"data-name":"Path 1361","d":"M96 20H4a4 4 0 00-4 4v72a4 4 0 004 4h92a4 4 0 004-4V24a4 4 0 00-4-4zm-4 55.434a15.925 15.925 0 010-30.867zM50 66a6 6 0 116-6 6.006 6.006 0 01-6 6zM8 44.57a15.918 15.918 0 010 30.856zm0 39.059a23.958 23.958 0 000-47.258v-8.375h38v18.039a3.729 3.729 0 00.117.586 13.9 13.9 0 000 26.758 3.729 3.729 0 00-.117.586v18.039H8zm46 8.375V73.965a3.728 3.728 0 00-.117-.586 13.9 13.9 0 000-26.758 3.729 3.729 0 00.117-.586V27.996h38v8.368a23.967 23.967 0 000 47.273v8.367z","fill":"#9ea7e9"}})])])
          )
        }
      }
    